// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"4134":"c473831ab63b0459","9188":"c0b20d088a81303a"}[chunkId] + ".css";
};